module.exports = __webpack_public_path__ + "img/phone-call.b5e84d61.svg";